
import Vue from 'vue'
import type { PropType } from 'vue'

export default Vue.extend({
  props: {
    size: {
      type: String as PropType<'sm' | 'md' | 'lg' | 'xlg'>,
      default: 'md',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    svgSize(): { w: number; h: number } {
      switch (this.size) {
        case 'xsm':
          return { w: 24, h: 24 }
        case 'sm':
          return { w: 30, h: 32 }
        case 'md':
          return { w: 42, h: 47 }
        case 'lg':
          return { w: 55, h: 61 }
        case 'xlg':
          return { w: 62, h: 69 }
        default:
          return { w: 42, h: 47 }
      }
    },
  },
})
